import React from 'react'
import { navigate, useLocation, useParams } from '@reach/router'
import { Button } from '@refera/ui-web'
import useRolePermission from '_/hooks/use-role-permission'
import { useBudgetForm } from '_/views/budget-view-v2/hooks/use-budget-form'
import { parse } from 'query-string'

export default function ExecutionDataButton() {
  const { budgetId, serviceOrderId } = useParams()
  const { search, pathname } = useLocation()
  useBudgetForm()
  const { isTradesman } = useRolePermission()
  const { verification_token: token } = parse(search)

  function handleClick() {
    const goToProviderExecution = token || isTradesman
    const query = token ? `?verification_token=${token}` : ''
    const path = `/chamado/${serviceOrderId}/orcamento/${budgetId}/execucao${
      goToProviderExecution ? '/prestador' : ''
    }${query}`

    navigate(path, { state: { from: pathname } })
  }

  return (
    <Button onClick={handleClick} color="primary" variant="secondary">
      Dados da execução
    </Button>
  )
}
